import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';
import { Divider, List, ListItem } from '@mui/material';
import useLocalization from 'hooks/useLocalization';
import { appLocales } from 'i18n';

const LanguageBar = (props) => {
    const { toggleContactUsModal } = props;
    const { formatMessage, locale } = useIntl();
    const { getMatchingRoute } = useLocalization();
    const history = useHistory();

    const changeLocale = (id) => {
        const locale = formatMessage({ id });
        const url = getMatchingRoute(locale);
        history.push(url, { from: { pathname: history.location?.pathname } });
    };

    return (
        <List className="language-bar">
            <ListItem
                aria-label={`change language to ${locale === appLocales.en ? 'french' : 'english'}`}
                button
                className="language-toggle btn"
                id="page-header-button-languageToggle"
                onClick={() => changeLocale('header.language')}
            >
                <FormattedMessage id="header.language.complete" />
            </ListItem>
            <Divider className="divider" flexItem orientation="vertical" variant="middle" />
            <ListItem
                aria-label="contact us"
                button
                className="contact-us btn"
                id="page-header-button-contactUs"
                onClick={toggleContactUsModal}
            >
                <FormattedMessage id="header.contactus" />
            </ListItem>
            <Divider className="divider" flexItem orientation="vertical" variant="middle" />
            <ListItem aria-label="Phone number" className="phone-number btn" id="page-header-button-phoneNumber">
                <a
                    href={
                        'tel:' +
                        formatMessage({
                            id: 'header.contactus.phone',
                        })
                    }
                    id="header.contactus.phone"
                >
                    <FormattedMessage id="header.contactus.phone" />
                </a>
            </ListItem>
        </List>
    );
};

export default LanguageBar;
